export const POLLING_TIMEOUT_MESSAGE =
  'Exceeded max number of tries to update submission status. Refresh this page to restart polling.'
